import Vue from 'vue';
import Router from 'vue-router';
import { isInIcestark,getBasename } from '@ice/stark-app';
import routes from '@/config/routes';

Vue.use(Router);
let base = process.env.VUE_APP_ROOT;
if (window.OarsContextPath){
  base = window.OarsContextPath
}
export default new Router({
  routes,
  mode: 'history',
  base: isInIcestark()?getBasename():base,
});
